export const OPEN_OWNERSHIP_MODAL = 'OPEN_OWNERSHIP_MODAL';
export const CLOSE_OWNERSHIP_MODAL = 'CLOSE_OWNERSHIP_MODAL';

function openOwnershipModal(changeOwnershipItem) {
  return {
    type: OPEN_OWNERSHIP_MODAL,
    isOwnershipModalShown: true,
    changeOwnershipItem,
  };
}

function closeOwnershipModal() {
  return {
    type: CLOSE_OWNERSHIP_MODAL,
    isOwnershipModalShown: false
  };
}

export function showOwnershipModal(item) {
  return (dispatch) => {
    dispatch(openOwnershipModal(item));
  };
}

export function hideOwnershipModal() {
  return (dispatch) => {
    dispatch(closeOwnershipModal());
  };
}
